"use strict";
import {Loader} from '@googlemaps/js-api-loader';

(function ($, Drupal, drupalSettings, once) {
  const GoogleMaps = GoogleMaps || {};
  const markers = [];
  const maps = drupalSettings.maps
  let googleMaps = [];

  Drupal.behaviors.mapsParagraph = {
    attach: function (context, settings) {

      let basePath = '/' + drupalSettings.path.themeUrl;
      const markerImage = basePath + '/images/svg-icon/blue-pin.svg';
      const markerImageLarge = basePath + '/images/svg-icon/blue-large-pin.svg';

      GoogleMaps.initMap = function () {
        let stylers = drupalSettings.maps.google_maps_stylers;
        let initial_latitude = null;
        let initial_longitude = null;
        let initial_zoom = null;

        if ($(maps.items).length > 0) {
          //maps.forEach(function (map, index) {
          for (const [index, map] of Object.entries(maps.items)) {
              initial_latitude = map.field_map_center.lat;
              initial_longitude = map.field_map_center.lon;
              initial_zoom = map.field_map_zoom;
              googleMaps['map'+index] = new google.maps.Map(document.getElementById("map-container-"+index), {
                center: {'lat': parseFloat(initial_latitude), 'lng': parseFloat(initial_longitude)},
                zoom: parseInt(initial_zoom),
                styles: stylers,
              });
              let branches = map.branches;
              if (branches.length > 0) {
                branches.forEach(function (element) {
                  // The marker, positioned at Uluru
                  const marker = new google.maps.Marker({
                    position: {lat: parseFloat(element.latitude), lng: parseFloat(element.longitude)},
                    map: googleMaps['map'+index],
                    icon: markerImage,
                  }).addListener('click', (function (i) {
                    const activeItem = $('.map-card .branch-item[data-index=' + element.id + ']');
                    let mapCard = $('.map-card');
                    let mapList = $('.map-select');
                    $('.branch-item').removeClass('active');
                    activeItem.addClass('active');

                    GoogleMaps.resetMarkers(markers);
                    GoogleMaps.toggleBounce(this);

                    // scrollToBranchElement($('.map-card'), $('.map-card .branch-item[data-index=' + element.id + ']').get(0));
                    $('html, body').animate({
                      scrollTop: mapList.offset().top,
                    });

                    scrollParentToChild(mapCard.get(0), activeItem.get(0));
                  }));

                  markers.push({
                    marker: marker["instance"],
                    index: element.id
                  });
                });
              }
            }

        }
      }

      GoogleMaps.toggleBounce = function toggleBounce(marker) {

        marker.setIcon(markerImageLarge);
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        }
      }

      GoogleMaps.resetMarkers = function resetMarkers(markers) {
        markers.forEach(function (marker) {
          marker.marker.setAnimation(null);
          marker.marker.setIcon(markerImage);
        })
      }

      once('initmap', 'article', context).forEach(function (element) {
        element.classList.add('processed');
        const loader = new Loader({
          apiKey: drupalSettings.maps.google_maps_api_key,
          version: "weekly",
          libraries: ["places"]
        });
        loader
        .load()
        .then((google) => {
          GoogleMaps.initMap()
        })
        .catch(e => {
          console.log("Error loading Google Maps API")
        });
      });

      once('mapsload', '.map-container', context).forEach(function (element) {
        element.classList.add('processed');
      });

      once('branch-items', '.branch-item', context).forEach(function (element) {
        $(element).on('click', function () {
          const elid = $(this).data('index');

          // Show sales for branch.
          Drupal.ajax({
            url: Drupal.url('sales/' + elid)
          }).execute();

          $('.branch-item').removeClass('active');
          $(this).addClass('active');

          if ($(this).data('lat') && $(this).data('lng')) {
            let lat = parseFloat($(this).data('lat'));
            let lng = parseFloat($(this).data('lng'));
            let indexMap = $(this).data('indexmap');
            console.log("MAP", googleMaps['map'+indexMap]);

            googleMaps['map'+indexMap].setCenter({
              lat: lat,
              lng: lng
            });

            let currentMarker = markers.findIndex(x => {
              return x.index == elid;
            });

            if (currentMarker !== -1) {
              GoogleMaps.resetMarkers(markers)
              GoogleMaps.toggleBounce(markers[currentMarker].marker);
            }
          }
        });
      });

      function scrollToBranchElement(container, element) {
        const doc = document.documentElement;
        const yourHeight = (window.pageYOffset || doc.scrollTop);
        console.log(element);
        console.log(yourHeight);
        element.scrollIntoView(true);
        window.scroll(0, yourHeight);
      }

      function scrollParentToChild(parent, child) {
        // Where is the parent on page
        var parentRect = parent.getBoundingClientRect();
        // What can you see?
        var parentViewableArea = {
          height: parent.clientHeight,
          width: parent.clientWidth
        };

        // Where is the child
        var childRect = child.getBoundingClientRect();
        // Is the child viewable?
        var isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

        // if you can't see the child try to scroll parent
        if (!isViewable) {
              // Should we scroll using top or bottom? Find the smaller ABS adjustment
              const scrollTop = childRect.top - parentRect.top;
              const scrollBot = childRect.bottom - parentRect.bottom;
              if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
                  // we're near the top of the list
                  parent.scrollTop += scrollTop;
              } else {
                  // we're near the bottom of the list
                  parent.scrollTop += scrollBot;
              }
        }

      }
    }
  };

})(jQuery, Drupal, drupalSettings, once);
